// extracted by mini-css-extract-plugin
export default {"loanInfoContainer":"PropertyStep_loanInfoContainer__XtwhP"};